import { useState } from "react";
import { Loader2, LogOut } from "lucide-react";
import { toast } from "sonner";
import api from "@/api";
import AdminTextsForm from "@/components/admin/AdminTextsForm";
import AdminImagesForm from "@/components/admin/AdminImagesForm";
import AdminGalleryManager from "@/components/admin/AdminGalleryManager";

const TABS = [
  { id: "testi", label: "Testi" },
  { id: "immagini", label: "Immagini" },
  { id: "galleria", label: "Galleria / Album" },
];

export default function AdminDashboard({ user, onLogout }) {
  const [tab, setTab] = useState("testi");
  const [loggingOut, setLoggingOut] = useState(false);

  const logout = async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    try {
      await api.post("/auth/logout");
      onLogout();
    } catch (e) {
      toast.error("Logout non riuscito, riprova.");
      setLoggingOut(false);
    }
  };

  return (
    <div className="mx-auto w-full max-w-6xl px-5 py-12 sm:px-8" data-testid="admin-dashboard">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-center">
        <div>
          <h1 className="font-display text-4xl font-bold uppercase tracking-tight text-white sm:text-5xl">
            Gestione contenuti
          </h1>
          <p className="mt-2 text-sm text-slate-400">
            Accesso: <span className="text-brand-ice">{user.email}</span> — le modifiche sono
            immediatamente visibili sul sito.
          </p>
        </div>
        <button
          onClick={logout}
          disabled={loggingOut}
          data-testid="admin-logout-button"
          className="flex w-fit items-center gap-2 border border-white/20 px-5 py-3 font-mono text-[11px] uppercase tracking-[0.2em] text-white transition hover:border-brand-red hover:text-brand-red disabled:opacity-60"
        >
          {loggingOut ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogOut className="h-4 w-4" />}
          Esci
        </button>
      </div>

      <div className="mt-10 flex flex-wrap gap-3" data-testid="admin-tabs">
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            data-testid={`admin-tab-${t.id}`}
            className={`border px-6 py-3 font-mono text-[11px] uppercase tracking-[0.2em] transition ${
              tab === t.id
                ? "border-brand-ice bg-brand-ice text-brand-teal"
                : "border-white/20 text-white/70 hover:border-brand-cyan hover:text-brand-ice"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="mt-10">
        {tab === "testi" && <AdminTextsForm />}
        {tab === "immagini" && <AdminImagesForm />}
        {tab === "galleria" && <AdminGalleryManager />}
      </div>
    </div>
  );
}
